import { TFunction } from 'i18next';

import * as yup from 'yup';

import { MEDICARE_PAYORS } from '../types';

import * as api from '../../../../../api';

const isAlphaNumeric = (s: string) => /^[\w\d]+$/i.test(s);

function isValidMemberId(
  payor: api.PatientInsuranceInformation.Payor | string,
  subscriberId: string,
): boolean {
  if (MEDICARE_PAYORS.includes(payor)) {
    // https://www.cms.gov/medicare/new-medicare-card/understanding-the-mbi.pdf
    const C = '(?:[1-9])'; // Numeric 1-9
    const N = '(?:[0-9])'; // Numeric 0-9
    const A = '(?:a|c|d|e|f|g|h|j|k|m|n|p|q|r|t|u|v|w|x|y)'; // Alphabetic character (excluding S, L, O, I, B, Z)
    const AN = `(?:${A}|${N})`;
    const subscriberRegex = new RegExp(
      `^${C}${A}${AN}${N}${A}${AN}${N}${A}${A}${N}${N}$`,
      'i',
    );

    // Used for outdated Medicare cards
    const oldSubscriberRegex = /\d{9}[a-z]/i;

    if (
      !subscriberRegex.test(subscriberId) &&
      !oldSubscriberRegex.test(subscriberId)
    ) {
      return false;
    }
  }

  return true;
}

export const requiredMsgFunc = (t: TFunction) =>
  t('requiredField', { ns: 'editInsurancePage' });
export const unableToReadMsgFunc = (t: TFunction) => t('unableToRead');

export const GENERAL_DETAILS_SCHEMA = (t: TFunction) => {
  const requiredMsg = requiredMsgFunc(t);

  return yup.object().shape({
    coverageStartDate: yup.date().nullable().notRequired(),
    groupNumber: yup.string().nullable().notRequired(),
    primaryPolicyHolderMemberId: yup
      .string()
      .min(1, t('memberIdCharacterMinimum'))
      .required(requiredMsg)
      .test(
        'primaryPolicyHolderMemberId',
        t('memberIdInvalidCharacter'),
        (item, { parent }) =>
          isAlphaNumeric(parent.primaryPolicyHolderMemberId),
      )
      .test(
        'primaryPolicyHolderMemberId',
        t('memberIdInvalidFormat'),
        (item, { parent }) =>
          isValidMemberId(parent.payor, parent.primaryPolicyHolderMemberId),
      ),
    payor: yup.string().required(requiredMsg),
  });
};
